<template>
  <div>
    <div class="left-header">
      <img src="img/liveswitch-logo-black.png" />
    </div>
    <div class="right-header">
      <a href="https://www.liveswitch.io/">LiveSwitch.io</a>
      <a href="https://developer.liveswitch.io/">Documentation</a>
      <a href="console.liveswitch.io">Console</a>
    </div>
    <div class="content">
      <div v-if="errorCode == 400 || errorCode == 404">
        <p>It looks like you don't have access to this environment.</p>
        <p>
          Has your trial expired? Contact
          <a href="mailto:sales@liveswitch.io">LiveSwitch Sales</a> about
          subscription options.
        </p>
        <p>
          Don't have an account?
          <a href="https://www.frozenmountain.com/signup-liveswitch-cloud"
            >Create one here</a
          >.
        </p>
        <p>
          Have a different issue? Check out our
          <a href="https://developer.liveswitch.io/">Documentation</a> or
          contact <a href="https://support.liveswitch.io/">Product Support</a >.</p>
      </div>
      <div v-else>
        <p>We're having trouble authenticating your request.</p>
        <p>Please clear your browser cookies and try again.</p>
        <p>
          If that didn't solve your problem, contact
          <a href="https://support.liveswitch.io/">Product Support</a>.
        </p>
      </div>
      <p>
        Error: <span>{{ error }}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {},
  computed: {
    errorCode() {
      return this.$route.query.code;
    },
    errorMessage() {
      return this.$route.query.message;
    },
    error() {
      return `${this.errorCode} ${this.errorMessage}`;
    }
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
@import "../../assets/scss/md/variables";
.left-header {
  display: inline-block;
  margin: 20px;
}
.right-header {
  float: right;
  margin: 20px;
}
.right-header a {
  margin-right: 30px;
}
.content {
  font-size: 16px;
  margin-top: 40px;
}
.content p {
  margin: 10px;
  text-align: center;
}
a {
  color: $brand-primary-dark !important;
}
</style>
